const PayrollRejectedTaskTableHeaders = () => [
];

const PayrollRejectedTaskItemFormatters = () => [
];

export { PayrollRejectedTaskTableHeaders, PayrollRejectedTaskItemFormatters };
